import { css, html, nothing, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { arrowForwardIcon, circlePlusIcon } from '../assets/icons';
import { TmBaseComponent } from '../tm-base.component';
import './tm-icon';

export const tagName = 'tm-action-button';
@customElement(tagName)
export class TmActionButton extends TmBaseComponent {
    @property({ reflect: true })
    public disabled = false;

    @property({ attribute: false })
    public icon?: TemplateResult<2>;

    @property({ attribute: false })
    public buttonTitle?: string;

    @property({ attribute: false })
    public buttonDescription?: string;

    @property({ type: String, reflect: true })
    public buttonStyle?: 'primary' | 'secondary' | 'tertiary' = 'primary';

    protected firstUpdated() {
        this.icon = this.icon ?? circlePlusIcon;
    }

    protected render() {
        const description = this.buttonDescription
            ? html`<div class="text-xs text-secondary">${this.buttonDescription}</div>`
            : nothing;
        return html`<button
            class=${classMap({
                'w-full': true,
                'w-full px-2 text-base text-left leading-5 h-[60px]':
                    this.buttonStyle === 'primary',
                'opacity-50 cursor-not-allowed': this.disabled,
            })}
        >
            <div
                class=${classMap({
                    'flex flex-row justify-between items-center w-full': true,
                    'min-h-14 h-[60px] p-1 rounded-lg bg-primary shadow':
                        this.buttonStyle === 'primary',
                    'p-2 border rounded-lg': this.buttonStyle === 'secondary',
                })}
            >
                <div class="flex items-center">
                    <tm-icon
                        .icon=${this.icon}
                        .color=${this.buttonStyle === 'primary'
                            ? 'var(--jh-color-gray-0)'
                            : 'var(--content-default)'}
                        class=${classMap({
                            'w-10 h-10 ml-1 mr-2 p-2 bg-brand rounded-full':
                                this.buttonStyle === 'primary',
                            'w-6 h-6 ml-1 mr-2': this.buttonStyle === 'secondary',
                        })}
                    ></tm-icon>
                    <div>
                        <div
                            class="font-medium text-header"
                            class=${classMap({
                                'text-header': true,
                                'font-medium': this.buttonStyle === 'primary',
                                'text-sm': this.buttonStyle === 'secondary',
                            })}
                        >
                            ${this.buttonTitle}
                        </div>
                        ${description}
                    </div>
                </div>
                <tm-icon
                    .icon=${arrowForwardIcon}
                    .color=${'var(--jh-color-gray-300)'}
                    class="arrow-icon mr-1"
                ></tm-icon>
            </div>
        </button>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}
declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmActionButton;
    }
}
